import { Injectable } from '@angular/core';
import { OpenApiRemoteMethod, OpenApiRemoteMethodParameter, RxapOpenApiRemoteMethod } from 'eurogard-open-api-remote-method';
import { NotificationAccordionSettingsControllerToggleAlarmingParameter } from '../parameters/notification-accordion-settings-controller-toggle-alarming.parameter';

@Injectable({
    providedIn: 'root'
  })
@RxapOpenApiRemoteMethod({
    serverId: 'service-feature-user',
    operationId: 'NotificationAccordionSettingsController_toggleAlarming',
    operation: '{"operationId":"NotificationAccordionSettingsController_toggleAlarming","parameters":[{"name":"uuid","required":true,"in":"path","schema":{"type":"string"}}],"responses":{"200":{}},"method":"put","path":"/notification-accordion/{uuid}/settings/toggle-alarming"}'
  })
export class NotificationAccordionSettingsControllerToggleAlarmingRemoteMethod extends OpenApiRemoteMethod<void, NotificationAccordionSettingsControllerToggleAlarmingParameter, void> {
  public override call(parameters: OpenApiRemoteMethodParameter<NotificationAccordionSettingsControllerToggleAlarmingParameter, void>): Promise<void> {
    return super.call(parameters);
  }
}
